function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  d: "M8 14.25h8M8 17.25h8"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 5.25,
  y: 3.25,
  width: 13.5,
  height: 17.5,
  rx: 1.25,
  stroke: "currentColor",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  d: "M8.75 6.75h6.5v4.5h-6.5z"
});

function SvgSurveyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default SvgSurveyIcon;